module.exports = __webpack_public_path__ + "static/media/spin_wheel_base.76be17df.png";